<template>
  <ul role="list" class="ui-subscription-plan-features">
    <SubscriptionPlanFeaturesItem
      v-for="feature in features"
      :key="feature"
      v-bind="{ feature }"
    />
  </ul>
</template>

<script setup lang="ts">
import SubscriptionPlanFeaturesItem from './SubscriptionPlanFeaturesItem.vue'

type Props = {
  features: string[]
}

defineProps<Props>()
</script>

<style>
.ui-subscription-plan-features {
  @apply flex flex-col;
  @apply gap-1;
  @apply text-base sm:text-sm leading-6;
  @apply text-gray-600 dark:text-gray-400;
}
</style>
